<template>
    <div id="root">
        <template v-if="!$route.meta.public && isSignIn">
            <v-app class="app" id="inspire">
                <app-drawer class="app-drawer"/>
                <app-header class="app-toolbar"/>
                <v-main class="page-wrapper">
                    <router-view/>
                </v-main>
            </v-app>
        </template>
        <template v-else>
            <transition>
                <keep-alive>
                    <router-view :key="$route.fullpath"/>
                </keep-alive>
            </transition>
        </template>
        <v-snackbar :color="snackbar.color" :timeout="5000" bottom right v-model="snackbar.show">
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.show = false" dark text icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import AppHeader from './app/app/AppHeader';
    import AppDrawer from "./app/app/NavigationBar";
    import AppEvents from './AppEvents';

    export default {
        name: 'App',
        components: {
            AppDrawer,
            AppHeader
        },
        data: () => ({
            snackbar: {
                show: false,
                color: "",
                text: ""
            }
        }),
        computed: {
            isSignIn() {
                return this.$store.getters["auth/isSignIn"];
            },
            isOnline() {
                return false;
            },
            version() {
                return "1.0.0";
            }
        },
        created() {
            window.app = this;
            AppEvents.forEach(event => {
                this.$on(event.name, event.callback);
            });
        },
        methods: {
            notification(color, msg) {
                this.snackbar.show = true;
                this.snackbar.color = color;
                this.snackbar.text = msg;
            }
        },
        watch: {
            $route() {
                this.$store.dispatch("alert/clear");
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .page-wrapper
        min-height: calc(100vh - 64px - 50px - 81px);

    .v-footer
        padding: 0 16px;

    .network-icon
        padding-left: 10px;
</style>